import { IConsultantContactsState } from '../../types/consultantContacts';
import { createNoopReducer } from '../../utils/redux/createNoopReducer';

export const INITIAL_STATE: IConsultantContactsState = {
  phone: null,
};

export const consultantContactsReducer = createNoopReducer<IConsultantContactsState>(INITIAL_STATE);
